export enum RecruitText {
  Recruit0 = 0,
  Recruit1 = 1,
  Recruit2 = 2,
}
